import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getContent = (key) =>
  axios.get(`${API}/content/${key}`).then((r) => r.data.value).catch(() => null);

export const saveContent = (key, value) =>
  axios.post(`${API}/content/${key}`, { value }).catch(() => null);
